import React, { useState } from 'react';
import axios from 'axios';

// Entrar y crear el negocio. Las dos cosas en la misma pantalla porque son la
// misma decisión: o ya tienes cuenta o la estás haciendo ahora.
function Puerta({ onEntrar }) {
  const [creando, setCreando] = useState(false);
  const [email, setEmail] = useState('');
  const [clave, setClave] = useState('');
  const [negocio, setNegocio] = useState('');
  const [error, setError] = useState('');
  const [ocupado, setOcupado] = useState(false);

  const enviar = async (e) => {
    e.preventDefault();
    setError('');
    setOcupado(true);
    try {
      const ruta = creando ? '/api/auth/register' : '/api/auth/login';
      const cuerpo = creando
        ? { email, password: clave, nombreNegocio: negocio }
        : { email, password: clave };
      const { data } = await axios.post(ruta, cuerpo);
      onEntrar({ token: data.token, user: data.user });
    } catch (err) {
      setError(err.response?.data?.error || 'No se pudo conectar con el servidor');
      setOcupado(false);
    }
  };

  return (
    <div className="puerta">
      <form onSubmit={enviar}>
        <span className="gema">🏢</span>
        <h1>{creando ? 'Crear el negocio' : 'Arriendos'}</h1>
        <p className="sub">
          {creando
            ? 'Se crea la cuenta y quedan listas las categorías para empezar.'
            : 'Inventario, ventas e instalaciones.'}
        </p>

        {error && <div className="aviso malo">{error}</div>}

        {creando && (
          <label className="campo">
            <span>Nombre del negocio</span>
            <input
              value={negocio}
              onChange={(e) => setNegocio(e.target.value)}
              placeholder="Arriendos La Esperanza"
              required
            />
          </label>
        )}

        <label className="campo">
          <span>Correo</span>
          {/* autoComplete deja que el teléfono ofrezca la huella o el rostro
              para rellenar. Sin estos atributos, el llavero no reconoce el
              formulario y hay que teclear la clave cada vez. */}
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
            required
          />
        </label>

        <label className="campo">
          <span>Contraseña</span>
          <input
            type="password"
            value={clave}
            onChange={(e) => setClave(e.target.value)}
            autoComplete={creando ? 'new-password' : 'current-password'}
            required
          />
        </label>

        <button className="boton" disabled={ocupado}>
          {ocupado ? 'Un momento…' : creando ? 'Crear el negocio' : 'Entrar'}
        </button>

        <p className="cambiar">
          {creando ? '¿Ya tienes cuenta?' : '¿Es la primera vez?'}{' '}
          <button type="button" onClick={() => { setCreando(!creando); setError(''); }}>
            {creando ? 'Entrar' : 'Crear el negocio'}
          </button>
        </p>
      </form>
    </div>
  );
}

export default Puerta;
